import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=e21b4d66"
import script from "./Identification.vue?vue&type=script&lang=ts"
export * from "./Identification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports